import { AuthService } from './../auth.service';
import {
  Component,
  OnInit,
  HostListener,
  ViewEncapsulation,
  Inject,
  OnDestroy,
  isDevMode,
} from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { environment } from '../../environments/environment';
import { ProfileService } from './my-profile/my-profile.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent implements OnInit, OnDestroy {
  userType!: any;
  nav_check: any = 0;
  sidebarCollapse = false;
  userDetails!: any;
  userEmail!: any;
  firstName: any;
  lastName: any;
  middleName: any;
  contactNumber: any;
  showMenu = false;
  sideNavStatus : any;
  dashboardExpanded : any = true;
  dashboardActive : any = false;
  phtype: any;
  pharmacyCollapse = [
    '/dashboard/medicines',
    '/dashboard/examinations_test',
    '/dashboard/interventions',
  ];
  country_conf_check: any;
  isDevMode = isDevMode();
  @HostListener('window:resize', ['$event'])
  onresize(event: any) {
    const target = event.target;
    if (target.innerWidth <= 990) {
      this.sidebarCollapse = true;
    }
  }
  profileSub!: Subscription;
  private readonly REACT_ORIGIN = environment.react_origin;
  private readonly REACT_BASE = environment.react_base;
  constructor(
    public router: Router,
    private authService: AuthService,
    public dialog: MatDialog,
    private profileService: ProfileService
  ) {
    // router.events
    //   .pipe(filter((ev) => ev instanceof NavigationStart))
    //   .subscribe((event: any) => {
    //     if (this.pharmacyCollapse.includes(event.url)) {
    //       this.nav_check = 1;
    //     }
    //   });
    this.userEmail = localStorage.getItem('email') || '';
    this.firstName = localStorage.getItem('fname');
    this.lastName = localStorage.getItem('lname');
    this.middleName = localStorage.getItem('mname');
    this.contactNumber = localStorage.getItem('contactNumber');
    this.phtype = localStorage.getItem('phtype');
    if (this.middleName == 'null') {
      this.middleName = undefined;
    }
    if (this.userEmail == 'null') {
      this.userEmail = undefined;
    }
    if (this.phtype == '1') {
      this.nav_check = 1;
    }
  }

  ngOnInit() {
    if (this.pharmacyCollapse.includes(this.router.url)) this.nav_check = 1;

    this.userType = +(localStorage.getItem('userTypeId') || 0);
    this.updateProfileHeader();
    this.router.events.subscribe((val) => {
      if (
        (this.router.url === '/dashboard/home' ||
          this.router.url === '/dashboard/tobacco-cessation') &&
        this.sidebarCollapse === true
      ) {
        this.dashboardActive = true;
      } else if (this.router.url !== '/dashboard/home') {
        this.dashboardActive = false;
      }
    });

  }
  ngOnDestroy(): void {
    if (this.profileSub) this.profileSub.unsubscribe();
  }

  onDasboardClick(): void {
    this.router.navigate(['home']);
  }

  toggleDashboard() : void {
this.dashboardExpanded = !this.dashboardExpanded;
if (
  (this.router.url === '/dashboard/home' ||
    this.router.url === '/dashboard/tobacco-cessation') &&
  this.dashboardExpanded === false
) {
  this.dashboardActive = true;
} else if (this.router.url !== '/dashboard/home') {
  this.dashboardActive = false;
}else{
  this.dashboardActive = false;

}
  }

  updateProfileHeader() {
    this.profileSub = this.profileService.profileUpdater.subscribe(() => {
      this.userEmail = localStorage.getItem('email') || '';
      this.firstName = localStorage.getItem('fname');
      this.lastName = localStorage.getItem('lname');
      this.middleName = localStorage.getItem('mname');
      this.contactNumber = localStorage.getItem('contactNumber') || '';
    });
  }

  sidebartoggler() {
    this.sidebarCollapse = !this.sidebarCollapse;
    if (
      (this.router.url === '/dashboard/home' ||
        this.router.url === '/dashboard/tobacco-cessation') 
    ) {
      this.dashboardActive = true;
    } else{
      this.dashboardActive = false;

    }
    
    console.log(this.router.url);
  }

  viewMenu(event: any) {
    this.showMenu = !this.showMenu;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
  nav_check_fun() {
    localStorage.setItem('phtype', '2');
    this.phtype = localStorage.getItem('phtype');
  }

  nav_service_mode_fun() {
    const token = localStorage.getItem('jwt_token');
    const firstName = localStorage.getItem('fname');
    const lastName = localStorage.getItem('lname');
    const email = localStorage.getItem('email');
    const fullName = `${firstName || ''} ${lastName || ''}`.trim();
  
    let sent = false;
    let newWindow: Window | null = null;
  
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== this.REACT_ORIGIN) return;
      if (event.data?.type === 'READY' && !sent) {
        sent = true;
        newWindow?.postMessage(
          { type: 'AUTH_TOKEN', token, fullName, email },
          this.REACT_ORIGIN
        );
        window.removeEventListener('message', handleMessage);
        clearTimeout(fallbackTimer);
      }
    };
  
    // ✅ Step 1: listener first
    window.addEventListener('message', handleMessage);
  
    // ✅ Step 2: then open popup
    newWindow = window.open(`${this.REACT_BASE}/service-mode`, '_blank');
  
    // ✅ Step 3: fallback in case READY is missed
    const fallbackTimer = setTimeout(() => {
      if (!sent && newWindow) {
        sent = true;
        newWindow.postMessage(
          { type: 'AUTH_TOKEN', token, fullName, email },
          this.REACT_ORIGIN
        );
        window.removeEventListener('message', handleMessage);
      }
    }, 4000);
  }
  

  nav_screen_site_fun() {
    const token = localStorage.getItem('jwt_token');
    const firstName = localStorage.getItem('fname');
    const lastName = localStorage.getItem('lname');
    const email = localStorage.getItem('email');
    const fullName = `${firstName || ''} ${lastName || ''}`.trim();
  
    let sent = false;
    let newWindow: Window | null = null;
  
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== this.REACT_ORIGIN) return;
      if (event.data?.type === 'READY' && !sent) {
        sent = true;
        newWindow?.postMessage(
          { type: 'AUTH_TOKEN', token, fullName, email },
          this.REACT_ORIGIN
        );
        window.removeEventListener('message', handleMessage);
        clearTimeout(fallbackTimer);
      }
    };
  
    // ✅ Step 1: listener first
    window.addEventListener('message', handleMessage);
  
    // ✅ Step 2: then open popup
    newWindow = window.open(`${this.REACT_BASE}/screening-sites`, '_blank');
  
    // ✅ Step 3: fallback in case READY is missed
    const fallbackTimer = setTimeout(() => {
      if (!sent && newWindow) {
        sent = true;
        newWindow.postMessage(
          { type: 'AUTH_TOKEN', token, fullName, email },
          this.REACT_ORIGIN
        );
        window.removeEventListener('message', handleMessage);
      }
    }, 4000);
  }

  nav_dashboard_site_fun() {
    const token = localStorage.getItem('jwt_token');
    const firstName = localStorage.getItem('fname');
    const lastName = localStorage.getItem('lname');
    const email = localStorage.getItem('email');
    const fullName = `${firstName || ''} ${lastName || ''}`.trim();
  
    let sent = false;
    let newWindow: Window | null = null;
  
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== this.REACT_ORIGIN) return;
      if (event.data?.type === 'READY' && !sent) {
        sent = true;
        newWindow?.postMessage(
          { type: 'AUTH_TOKEN', token, fullName, email },
          this.REACT_ORIGIN
        );
        window.removeEventListener('message', handleMessage);
        clearTimeout(fallbackTimer);
      }
    };
  
    // ✅ Step 1: listener first
    window.addEventListener('message', handleMessage);
  
    // ✅ Step 2: then open popup
    newWindow = window.open(`${this.REACT_BASE}/dashboard`, '_blank');
  
    // ✅ Step 3: fallback in case READY is missed
    const fallbackTimer = setTimeout(() => {
      if (!sent && newWindow) {
        sent = true;
        newWindow.postMessage(
          { type: 'AUTH_TOKEN', token, fullName, email },
          this.REACT_ORIGIN
        );
        window.removeEventListener('message', handleMessage);
      }
    }, 4000);
  }
  open_nav(check: any) {
    if (check == 0) {
      this.nav_check = 1;
    }
    if (check == 1) {
      this.nav_check = 0;
    }
    if (this.nav_check == 1) {
      // if (this.phtype != '1') {
      //   this.router.navigate(['/dashboard/medicines']);
      //   localStorage.setItem('phtype', '1');
      // }
    }
  }

  changePassword() {
    this.router.navigate(['/change-password']);
  }

  myprofile() {
    this.router.navigate(['/dashboard/my-profile']);
  }
}
export interface Country_list {
  countryCode: string;
  countryId: number;
  countryLanguage: string;
  countryName: string;
}
@Component({
  selector: 'app-country-conf',
  templateUrl: 'country-conf.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class CountryConfComponent {
  country: any;
  token: any;
  api_url = environment.api_endpoint;
  country_data: any;
  secondry_lang: any;
  country_list: any;
  userType: any;
  button_flag: any = true;
  country_code: any;
  country_id: any;
  culture_id: any;
  constructor(
    public router: Router,
    private authService: AuthService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CountryConfComponent>
  ) {
    this.token = localStorage.getItem('jwt_token');
    this.userType = localStorage.getItem('user_type');
  }

  ngOnInit() {
    this.authService
      .apiGet('available_countries', null)
      .subscribe((data: any) => {
        this.country_list = data;
      });
  }
  selectCountry(event: any) {
    this.secondry_lang = null;
    this.culture_id = null;
    this.country_id = event.value;
    this.button_flag = false;
    let path = 'country_secondary_language?countryId=' + this.country_id;
    this.authService.apiGet(path, null).subscribe((data: any) => {
      this.secondry_lang = data.language;
      this.culture_id = data.culture_id;
      // if (this.secondry_lang != undefined) {
      //   this.button_flag = false;
      // } else {
      //   this.button_flag = true;
      // }
    });
  }
  save() {
    let data_json = {
      cultureId: this.culture_id,
      countryId: this.country_id,
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: '450px',
      data: data_json,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'confirm') {
        this.dialogRef.close('confirm');
      }
    });
  }
  cancel() {
    this.dialogRef.close();
  }
}

export interface DialogData {
  id: any;
  view: any;
}

@Component({
  selector: 'app-confirm-box',
  templateUrl: 'confirm-box.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class ConfirmComponent {
  get_data: any;
  save_flag: boolean = false;
  type: any;
  send_id: any;
  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<ConfirmComponent>
  ) {
    this.get_data = data;
  }

  ngOnInit() {}
  toggel_change(event: any) {}
  confirm() {
    this.authService.apiCountryConf(this.get_data).subscribe(
      (res: any) => {
        this.snackBar.open(res.message, '', {
          duration: 2000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
        const dialogRef = this.dialog.open(DetailComponent, {
          width: '500px',
        });
        dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef.close('confirm');
        });
      },
      (error) => {
        this.snackBar.open('Something went wrong', '', {
          duration: 5000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
      }
    );
  }
  cancel() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'app-view-box',
  templateUrl: 'view_details.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DetailComponent {
  get_data: any;
  country: any;
  name_secondary_language: any;
  color = 'accent';
  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<DetailComponent>
  ) {}

  ngOnInit() {
    this.authService.apiGet('current_configurations', null).subscribe(
      (data: any) => {
        this.country = data.name;
        this.get_data = data;
        this.name_secondary_language = data.secondary_lang_name;
      },
      (error) => {
        this.snackBar.open('Something went wrong', '', {
          duration: 2000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
      }
    );
  }
  copy_text(json: any) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = JSON.stringify(this.get_data);
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    let message = 'Json for country server copied to clipboard';
    this.snackBar.open(message, '', {
      duration: 3000,
    });
  }
  cancel() {
    this.dialogRef.close(this.get_data);
  }
}
